/**
 * Custom Collection Slider Component
 * Handles Swiper initialization for product carousels
 */
class CustomCollectionSlider {
  constructor() {
    this.init();
  }

  init() {
    this.initSwiper();
  }

  initSwiper() {
    const swiperElements = document.querySelectorAll('.custom-collection-swiper');
    
    if (swiperElements.length === 0) return;

    swiperElements.forEach((element) => {
      new Swiper(element, {
        slidesPerView:'auto',
        loop:swiperElements.length > 3 ? true : false,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: document.querySelector('#custom-collection-next'),
          prevEl: document.querySelector('#custom-collection-prev'),
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          480: {
            slidesPerView: 2,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
          1024: {
            slidesPerView: 'auto',
            spaceBetween: 0,
          },
        },
      });
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new CustomCollectionSlider();
});

// Export for potential external use
if (typeof module !== 'undefined' && module.exports) {
  module.exports = CustomCollectionSlider;
}
